// The app's routes: every src/app/**/page.tsx and layout.tsx, discovered at
// build time (buildRoutes.tsx documents the folder → path rules).

import NotFound from "@/app/not-found";

import { buildRoutes, type LayoutModule, type PageModule } from "./buildRoutes";
import { RouteErrorBoundary } from "./RouteErrorBoundary";

export const appRoutes = buildRoutes({
  pages: import.meta.glob<PageModule>("../app/**/page.tsx"),
  layouts: import.meta.glob<LayoutModule>("../app/**/layout.tsx"),
  notFound: <NotFound />,
  errorElement: <RouteErrorBoundary />,
});
